<template>
  <section class="view-stack">
    <article class="dashboard-panel model-catalog-panel">
      <div class="panel-heading model-catalog-heading">
        <div>
          <h2>可用模型</h2>
          <p>查看当前公开支持的 Codex 模型、首字平均耗时、可用率及 Token 计费价格。</p>
        </div>
        <el-button
          type="primary"
          plain
          icon="el-icon-refresh"
          :loading="loading"
          @click="loadModels"
        >
          刷新
        </el-button>
      </div>

      <div class="model-catalog-summary">
        <div>
          <span>当前公开模型</span>
          <strong>{{ models.length }}</strong>
        </div>
        <span class="model-catalog-unit">价格单位：USD / 1M</span>
      </div>

      <ModelPriceTable :models="models" :loading="loading" />
    </article>
  </section>
</template>

<script>
import ModelPriceTable from '../../components/ModelPriceTable.vue';
import { fetchPublicSupportedModels } from '../../api/keys';

export default {
  name: 'ModelsView',
  components: { ModelPriceTable },
  data() {
    return {
      loading: false,
      models: []
    };
  },
  created() {
    this.loadModels();
  },
  methods: {
    async loadModels() {
      this.loading = true;
      try {
        const response = await fetchPublicSupportedModels();
        const result = response.data || {};
        if (result.code !== 0) {
          throw new Error(result.message || '模型列表加载失败');
        }
        this.models = Array.isArray(result.data) ? result.data : [];
      } catch (error) {
        this.models = [];
        this.$message.error(error.message || '模型列表加载失败，请稍后重试');
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.model-catalog-summary {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 18px;
  padding: 14px 16px;
  color: #536d78;
  background: #f5fbf8;
  border: 1px solid #dcefe8;
  border-radius: 8px;
}

.model-catalog-summary > div {
  display: flex;
  align-items: baseline;
  gap: 10px;
  min-width: 0;
}

.model-catalog-summary span {
  font-size: 13px;
}

.model-catalog-summary strong {
  color: #0f856e;
  font-size: 24px;
  line-height: 1;
}

.model-catalog-summary small {
  color: #83959d;
  font-size: 12px;
}

.model-catalog-unit {
  flex: 0 0 auto;
}

@media (max-width: 640px) {
  .model-catalog-heading .el-button {
    flex: 0 0 auto;
  }

  .model-catalog-summary {
    align-items: flex-start;
    flex-direction: column;
    gap: 8px;
  }

  .model-catalog-summary > div {
    flex-wrap: wrap;
  }
}
</style>
